import { render } from "./DownloadApp.vue?vue&type=template&id=c0772b58&scoped=true&ts=true"
import script from "./DownloadApp.vue?vue&type=script&lang=ts"
export * from "./DownloadApp.vue?vue&type=script&lang=ts"

import "./DownloadApp.vue?vue&type=style&index=0&id=c0772b58&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0772b58"]])

export default __exports__